export const STATUS_DRAFT = "Draft";
export const STATUS_SUBMITTED = "Submitted";
export const STATUS_ACCEPTED = "Accepted";
export const STATUS_REJECTED = "Rejected";
export const STATUS_ARCHIVED = "Archived";

export const PROJECT_STATUSES = [
  "Not Started",
  "Blocked",
  "Cancelled",
  "Completed",
  "In Progress",
  "On Hold",
  "Waiting for Resource"
];

export const EXCEPTION_PROJECT_STATUSES = [
  STATUS_DRAFT,
  STATUS_SUBMITTED,
  STATUS_ACCEPTED,
  STATUS_REJECTED,
  STATUS_ARCHIVED
];

export const PROJECT_TYPES = [
  "Threat Modeling",
  "Code Review",
  "Pen Testing",
  "On-demand Testing",
  "Security Testing",
  "Compliance",
  "Debt Reduction Campaign",
  "Remediation Plan",
];

export const OWNER_FIELDS = ["engineeringOwner", "securityOwner", "businessOwner", "complianceOwner", "supportOwner"];
